module.exports = __webpack_public_path__ + "static/media/favorites-empty-black.8105f5c8.svg";